// extracted by mini-css-extract-plugin
module.exports = {"frame":"founder-profile_frame__m32fy"};